export const galleryConstants = {
  GALLERY_IMAGES: "GALLERY_IMAGES",
  GALLERY_VIDEOS: "GALLERY_VIDEOS",
  GALLERY_REELS: "GALLERY_REELS",
  CONTENT_TYPE_REELS : "reel",
  CONTENT_TYPE_FILES : "file"
};
